// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"551":"620de758","579":"59577f8f","584":"38b22238","599":"b615184d","787":"84aef60c"}[chunkId] + ".chunk.js";
};